import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../hooks/useLanguage';
export function PainSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-20 px-4 bg-gradient-to-b from-[#0A0A0F] to-[#111118]" data-id="element-105">
      <div className="max-w-3xl mx-auto" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-107">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 border-l-4 border-[#DC2626] pl-6" data-id="element-108">
            {t('pain_h2')}
          </h2>

          <p data-id="element-109">
            {t('pain_p1_before')}{' '}
            <span className="text-white italic" data-id="element-110">{t('pain_p1_quote')}</span>
            {t('pain_p1_after')}
          </p>

          <p data-id="element-111">{t('pain_p2')}</p>

          <div className="bg-[#1A1A24] p-6 rounded-lg border border-gray-800 font-mono text-sm md:text-base text-gray-400 my-8" data-id="element-112">
            {t('pain_rejection')}
          </div>

          <p className="font-semibold text-white" data-id="element-113">{t('pain_p3')}</p>

          <div className="h-px w-full bg-gradient-to-r from-transparent via-gray-800 to-transparent my-12" data-id="element-114" />

          <p data-id="element-115">{t('pain_p4')}</p>
        </motion.div>
      </div>
    </section>;
}